// src/utils/dayjsConfig.js
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// extend plugins once
dayjs.extend(utc);
dayjs.extend(timezone);

// set global default timezone
dayjs.tz.setDefault("America/Chicago");  // US Central Time

export default dayjs;
